import * as React from "react";
import { Typography } from "@/core/components/ui/typography/typography";
import { cn } from "@/core/utils/utils";

interface TextareaProps extends React.ComponentProps<"textarea"> {
  label?: string;
  required?: boolean;
  disableRequirementAsterisk?: boolean;
  disablePlaceholderAsterisk?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      className,
      label,
      required,
      disableRequirementAsterisk,
      placeholder,
      disablePlaceholderAsterisk,
      ...props
    },
    ref,
  ) => {
    const plainPlaceholder = !placeholder ? label : placeholder;
    const placeholderWithAsterisk =
      required && !disablePlaceholderAsterisk
        ? `${plainPlaceholder} *`
        : plainPlaceholder;

    return (
      <div className="flex w-full flex-col gap-2">
        {label && (
          <Typography variant="subtitleW3" textColor="interactive">
            {label}
            {required && !disableRequirementAsterisk && (
              <span className="ml-1">*</span>
            )}
          </Typography>
        )}
        <textarea
          className={cn(
            "m-px flex min-h-[8rem] w-full rounded-lg border border-input bg-transparent px-3 py-2 pt-4 text-lg shadow-sm placeholder:text-lg placeholder:text-tertiary-text focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            className,
          )}
          ref={ref}
          placeholder={placeholderWithAsterisk}
          {...props}
        />
      </div>
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
